import { render, staticRenderFns } from "./AlarmLevelIcon.vue?vue&type=template&id=4b7d80c8&scoped=true"
import script from "./AlarmLevelIcon.vue?vue&type=script&lang=ts"
export * from "./AlarmLevelIcon.vue?vue&type=script&lang=ts"
import style0 from "./AlarmLevelIcon.vue?vue&type=style&index=0&id=4b7d80c8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b7d80c8",
  null
  
)

export default component.exports